// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles__keyboard___1F75g {\n  display: flex;\n  height: 10em;\n  margin: 20px 0;\n}\n", ""]);
// Exports
exports.locals = {
	"keyboard": "styles__keyboard___1F75g"
};
module.exports = exports;
